export { default } from "./personalInformation";
